import React from "react";
import ProductGallery from "../../GalleryImagesComponent";
import Image1 from "../../../../Product/School_Uniforms/Vests/V1.webp";
import Image2 from "../../../../Product/School_Uniforms/Vests/V2.webp";
import Image3 from "../../../../Product/School_Uniforms/Vests/V3.webp";
import Image4 from "../../../../Product/School_Uniforms/Vests/V4.webp";
import Image5 from "../../../../Product/School_Uniforms/Vests/V5.webp";
import Image6 from "../../../../Product/School_Uniforms/Vests/V6.webp";

const VestsSchool = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6];

  return (
    <ProductGallery
      images={images}
      category={{ english: "school_uniform", enName: "Educational", arabic: "التعليم", arName: "التعليم" }}
      product={{ english: "Vests", arabic: "سترات" }}
    />
  );
};

export default VestsSchool;
